export const REPORT_REQUEST_CACHE_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  ERROR: 'error',
  NOT_FOUND: 'NOT_FOUND'
};
// aiming for 10-15 seconds timeout
export const DEFAULT_POLL_INTERVAL = 500;
export const DEFAULT_MAX_POLL_ATTEMPTS = 20;
export const RELATIONAL_REPORT_POLL_INTERVAL = 2000;
export const RELATIONAL_REPORT_MAX_POLL_ATTEMPTS = 5;